export default "__VITE_ASSET__635030fc__"